"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioToken = void 0;
var AudioCategory = require("./AudioCategory");
var AudioToken = /** @class */ (function () {
    function AudioToken(pId, pVolume, pLoop, pCategory) {
        if (pVolume === void 0) { pVolume = 1; }
        if (pLoop === void 0) { pLoop = false; }
        if (pCategory === void 0) { pCategory = AudioCategory.DEFAULT; }
        this.id = pId;
        this.volume = pVolume;
        this.loop = pLoop;
        this.category = pCategory;
    }
    return AudioToken;
}());
exports.AudioToken = AudioToken;
//# sourceMappingURL=AudioToken.js.map